<template>
    <v-navigation-drawer
       v-model="opened"
       height="100vh"
       width="350"
       location="right"
       floating
       fixed
       temporary
       hide-overlay
       class="drawer-info">

       <div class="header-drawer">
         <span >Detalles</span>
           <v-icon class="mr-2"
           @click="opened = false">
             mdi-close
           </v-icon>
       </div>

       <div class="container-data-drawer">
         <div class="container-element-drawer"
         v-if="collaborator.role">
           <span class="title-elemet-drawer">Rol</span>
           <span class="element-drawer">
            {{ collaborator.role ? collaborator.role.description : "" }}
          </span>
         </div>

         <div class="container-element-drawer">
           <span class="title-elemet-drawer">Nombre</span>
           <span class="element-drawer">{{ collaborator.name }}</span>
         </div>

         <div class="container-element-drawer">
           <span class="title-elemet-drawer">Email</span>
           <span class="element-drawer">{{ collaborator.email }}</span>
         </div>
         <div class="container-element-drawer">
           <span class="title-elemet-drawer">Terminal de venta u operación</span>
           <span class="element-drawer">
            {{ collaborator.terminal ? collaborator.terminal.name : "" }}
          </span>
         </div>
       </div>

       <div class="container-bottom-drawer">
         <v-btn
           color="#FF5700"
           class="btn-outline-drawer"
           variant="outlined"
           rounded="xl"
           @click="openEdit">
           Editar
         </v-btn>
       </div>

    </v-navigation-drawer>
</template>

<script>
import dateTransform from '@/utils/dateTransform'
export default {
  name: 'CommerciaVueCollaboratorsDrawer',
  emits: ['openEdit'],
  data () {
    return {
      opened: false,
      collaborator: {
        business: null,
        terminal: null,
        role: null,
        name: null,
        email: null,
        active: null,
        password: null,
        _id: null,
        created_at: null,
        updated_at: null
      }
    }
  },

  methods: {
    show (collaborator) {
      this.opened = true
      this.collaborator = structuredClone(collaborator)
      this.panelOpen = [0]
    },
    openEdit () {
      this.opened = false
      this.$emit('openEdit', this.collaborator)
    },
    formatTimestamp (timestamp) {
      return dateTransform.timestampToFormat(timestamp)
    }
  }
}
</script>

<style scoped>
  @import '@/assets/styles/drawers.css';
</style>
